import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrowup",
  "use": "arrowup-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 10 6\" id=\"arrowup\">\n<style type=\"text/css\">\n\t#arrowup .st0{fill:#1E2330;}\n</style>\n<path class=\"st0\" d=\"M5,0c0.3,0,0.5,0.1,0.7,0.3l4,4c0.4,0.4,0.4,1,0,1.4s-1,0.4-1.4,0L5,2.4L1.7,5.7c-0.3,0.4-1,0.4-1.4,0\n\ts-0.4-1,0-1.4l4-4C4.5,0.1,4.7,0,5,0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol